import React from 'react'
import Manager from 'tyan/public/components/Manager'
import ExpenseOrder from './ExpenseOrder'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '报支单号', field: 'Number', minWidth: 150, flex: 1, search: true },
        { _text: '报支类别', field: 'ExpenseName', minWidth: 150, flex: 1, search: true },
        { _text: '报支对象', field: 'CustomerName', renderer: (v, r) => r.data.报支名称 == '交际费报支单' ? r.data.报支人 : r.data.报支对象, minWidth: 200, flex: 1, filter: false },
        { _float: '支付金额', field: 'PayAmount', minWidth: 150, flex: 1, zeroValue: null, filter: true },
        { _text: '币别', field: 'Currency', minWidth: 100, flex: 1, search: true },
        { _text: '采购单号', field: 'PurchaseOrderNo', minWidth: 150, flex: 1, search: true },
        { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1, search: true },
        { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, search: true },
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
        { _: 'taskName', field: 'Task.TaskName' },
        { _: '报支名称', field: 'ExpenseName', minWidth: 150, flex: 1, search: true },
        { _: '报支对象', field: 'CustomerName', minWidth: 150, flex: 1, search: true },
        { _: '报支人', field: 'RelatedPerson', minWidth: 150, flex: 1, search: true },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <ExpenseOrder {...props} id={data.id} taskName={data.taskName} />)
    }
}

export default props => <Manager {...props} config={config} />